import styled from 'styled-components';

export const PrefWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 10px auto;
  padding: 0px 10px;
  max-width: 1100px;
  box-sizing: border-box;
  width: 100%;
`;

export const PrefTitle = styled.h3`
  color: white;
  margin: 0;
  font-weight: 300;
`;

export const PrefSelector = styled.div`
  display: flex;
  margin: auto 0px;
  margin-left: auto;
`;
